import { BehaviorSubject, Observable } from 'rxjs';
import { Disposable } from '../../hooks/useConstant';
import { createServiceModule } from '@aesop-fables/containr';

export const takeHomePayWarningWizardKey = 'services/takeHomePayWarningWizard';

// Flagged from account wizards (retirement plan, HSA, investment real estate) when a change may
// affect take-home pay, and consumed by whichever of the summary screen or Accounts tab mounts
// first, so the warning toast surfaces there instead of mid-wizard.
class TakeHomePayWarningWizard implements Disposable {
  private state = new BehaviorSubject<boolean>(false);

  constructor() {}

  get state$(): Observable<boolean> {
    return this.state;
  }

  flag(): void {
    this.state.next(true);
  }

  consume(): boolean {
    const flagged = this.state.value;
    if (flagged) {
      this.state.next(false);
    }
    return flagged;
  }

  dispose(): void {
    console.log('disposing TakeHomePayWarningWizard');
  }
}

export const withTakeHomePayWarningWizard = createServiceModule(
  takeHomePayWarningWizardKey,
  (services) => {
    services.use<TakeHomePayWarningWizard>(takeHomePayWarningWizardKey, TakeHomePayWarningWizard);
  }
);

export { TakeHomePayWarningWizard };
